<template>
  <component
    :is="isMobile ? CoreBottomSheet : CoreDialog"
    v-model="invasiveServiceInfoStore.isOpenedReferralForServiceModal "
    v-bind="isMobile
      ? { slotActionsClass: 'flex-column' }
      : { size: 'lg' }"
    data-qa="referral_for_service_modal"
  >
    <template
      v-if="!isMobile"
      #prependBtn="{ btnProps }"
    >
      <v-btn
        v-bind="btnProps"
        @click="invasiveServiceInfoStore.isOpenedReferralForServiceModal = false"
      >
        <span class="ui-icon-close-not-a-circle" />
      </v-btn>
    </template>
    <v-img
      alt=""
      src="/static/_v1/pd/pictures/appointment/referral-for-service.svg"
      height="150"
      width="150"
      class="mx-auto mb-5"
    />
    <div
      class="text-h6 text--text text-center mx-auto mb-2"
      data-qa="preliminary_consultation_title"
    >
      У вас есть направление на&nbsp;процедуру?
    </div>
    <div
      class="text-body-1 text-secondary--text text-center mx-auto"
      data-qa="preliminary_consultation_subtitle"
    >
      Нужно будет загрузить скан или фото направления
    </div>

    <template #actions>
      <v-btn
        data-qa="referral_for_service_modal_btn_no"
        color="bg-primary"
        :class="isMobile ? 'order-1 w-100' : 'w-0 flex-grow-1'"
        depressed
        @click="handleClickNo"
      >
        <span class="primary--text">
          Нет
        </span>
      </v-btn>
      <v-btn
        data-qa="referral_for_service_modal_btn_yes"
        color="bg-primary"
        :class="isMobile ? 'w-100' : 'w-0 flex-grow-1'"
        depressed
        @click="handleClickYes"
      >
        <span class="primary--text">
          Да
        </span>
      </v-btn>
    </template>
  </component>
</template>

<script lang="ts" setup>
import CoreBottomSheet from 'src/core/CoreBottomSheet/CoreBottomSheet.vue'
import CoreDialog from 'src/core/CoreDialog/CoreDialog.vue'
import useYandexGoals from 'src/composables/useYandexGoals'
import useInvasiveServiceInfoStore from 'src/components/common/InvasiveServiceInfo/stores/useInvasiveServiceInfoStore'

const isMobile = window.MOBILE_VERSION

const invasiveServiceInfoStore = useInvasiveServiceInfoStore()
const { sendYaGoal } = useYandexGoals()

function handleClickNo() {
  sendYaGoal('invasiveServiceInfo__clickHaveNoReferral')
  invasiveServiceInfoStore.isOpenedReferralForServiceModal = false
  invasiveServiceInfoStore.isOpenedPreliminaryConsultationModal = true
}

function handleClickYes() {
  sendYaGoal('invasiveServiceInfo__clickHaveReferral')
  invasiveServiceInfoStore.handleConfirmReferral()
}
</script>
